<template>
    <div>
      <transition appear name="slide-right">
          <div class="navigation">
              <div class="profile">
                
                <div class="profile__image-wrapper">
                  <img v-if="$shared.user.profile && $shared.user.profile.profile_image" :src="$shared.user.profile.profile_image.file.url" alt="">
                  <img v-else src="@/assets/images/profileLight.svg">
                </div>
                
                <h3 v-if="$shared.user.profile">{{$shared.user.profile.name}}</h3>
                <h5 v-if="$shared.user.type">{{$t($shared.user.type)}}</h5>
                  <!--
                  <h1>04</h1>
                  <div class="divider"></div>
                  <p>Bewerber</p>
                  <div class="adress" v-if="$shared.user.profile">
                      <img src="@/assets/images/mapMarkerSmall.svg"></img>
                      <a class="ellipsis" href="#">{{$shared.user.profile.address}}</a>
                  </div>
                  -->
                <br>
              </div>
              <div class="menu">
                  <router-link to="/me">
                      <img src="@/assets/images/profilIcon.svg"/>
                      <h2>Profil</h2>
                  </router-link>

                  <template v-if="$shared.user.type && $shared.user.type == 'Employer'">
                    <router-link to='/applicants'>
                        <img src="@/assets/images/bewerberIcon.svg"/>
                        <h2>Bewerber</h2>
                    </router-link>
                  </template>

                  <router-link to='/employers'>
                      <img src="@/assets/images/steuerberaterIcon.svg"/>
                      <h2>Steuerberater</h2>
                  </router-link>

    <!--
                  <router-link to='/settings'>
                      <img src="@/assets/images/einstellungenIcon.svg"/>
                      <h2>Einstellungen</h2>
                  </router-link>
    -->

                  <router-link to='/logout'>
                      <img src="@/assets/images/logoutIcon.svg"/>
                      <h2>Logout</h2>
                  </router-link>

                  
                  <template v-if="$shared.user.type && $shared.user.type == 'Employer'">
                    <a class="neuerBewerber" href="#" @click.prevent="$modal.show('new_applicant')">
                        <img src="@/assets/images/plusIcon.svg"/>
                        <h2>Neuer Bewerber</h2>
                    </a>
                  </template>
                  <template v-if="$shared.admin">
                    <a class="neuerBewerber" href="#" @click.prevent="$modal.show('new_employer')">
                        <img src="@/assets/images/plusIcon.svg"/>
                        <h2>Neue Ausbilder</h2>
                    </a>
                  </template>
              </div>

              <div class="menu--footer">
                <router-link to='/datenschutz'>
                  <a href="">Datenschutz</a>
                </router-link>

                <router-link to='/impressum'>
                  <a href="">Impressum</a>
                </router-link>

                <router-link to='/nutzungsbedingungen'>
                  <a href="">Nutzungsbedingungen</a>
                </router-link>
              </div>
          </div>
      </transition>
      <modal name="new_applicant" title="Neuer Bewerber">
          Geben Sie die E-Mail-Adresse des neuen Bewerbers ein:<br>
          <br>
          <input v-model="token_mail" type="text" class="input" placeholder="anna.mueller@gmx.de">

          <div slot="footer" >
              <stb-button name='Bewerber einladen' @click.native="create_token('Applicant')" />
          </div>
      </modal>

      <modal name="new_employer" title="Neuer Ausbilder">
          Geben Sie die E-Mail-Adresse der neuen Ausbilder ein:<br>
          <br>
          <input v-model="token_mail" type="textarea" class="input" placeholder="anna.mueller@gmx.de">

          <div slot="footer" >
              <stb-button name='Ausbilder einladen' @click.native="create_token('Employer')" />
          </div>
      </modal>
  </div>
</template>

<script>
import Parse from 'parse'
import {toast} from '@/utils/interactions'

export default {
    data() {
        return {
          token_mail: ''
        };
    },
    methods: {
        navigate(path) {
            this.$router.push(path);
        },
        create_token(type) {
            var mail = '' + this.token_mail;
            this.$modal.close('new_applicant');
            this.$modal.close('new_employer');
            this.token_mail = '';
            var data = {
                mail: mail,
                type: type,
                employer: this.$shared.user.profile.objectId,
            }
            Parse.Cloud.run('send_invitation_link', data).then((result) => {
                if (result) {
                  toast('Der Nutzer wurde ins Portal eingeladen.');
                } else {
                    // TODO: error handling
                    toast(
                        'Ein Fehler ist aufgetreten. Bitte wenden Sie sich an den Administrator.'
                    );
                }
            }).catch(() => {
                // TODO: error handling
                toast(
                    'Ein Fehler ist aufgetreten. Bitte wenden Sie sich an den Administrator.'
                );
            });
        },
    },
}
</script>


<style scoped lang="scss">
    
.navigation {
  position: fixed;
  bottom: 0pt;
  width: 30vw;
  max-width: 16em;
  height: calc(100vh - 0.9em - 1.3em - 18pt);
  overflow-x: scroll;
  z-index: 2;
  display: flex;
  flex-direction: column;
  background-color: $light-bg-color; }
  .navigation .profile {
    background-color: #ff805d;
    text-align: center; }

    .navigation .profile__image-wrapper {
      width: 40%;
      margin: 1.5em 0em 1em 0em;
      padding-bottom: 40%;
      overflow: hidden;
      border-radius: 200px;
      display: inline-block;
      position: relative;
      @include drop-shadow();
    }
    .navigation .profile img {
      width: 100%;
      height: 100%;
      top: 0px;
      left: 0px;
      position: absolute;
      object-fit: cover;
    }
    .navigation .profile h5 {
      font-family: Nunito;
      font-size: 14px;
      color: $light-bg-color;
      letter-spacing: 0.84px;
      opacity: 0.5;
      font-weight: 300; }
    .navigation .profile h1 {
      font-family: Nunito;
      font-size: 42px;
      line-height: 30px;
      letter-spacing: 3.74px;
      color: $light-bg-color;
      margin-top: 1em;
      opacity: 1; }
    .navigation .profile .divider {
      background-color: $light-bg-color;
      opacity: 0.65;
      height: 1.5pt;
      width: 4.4em;
      margin: 6pt calc(50% - 2.2em); }
    .navigation .profile p {
      font-family: Nunito;
      font-size: 11px;
      letter-spacing: 0.66px;
      color: $light-bg-color;
      opacity: 0.5;
      font-weight: 300; }
    .navigation .profile .adress {
      text-align: left;
      overflow: hidden;
      padding: 1em;
      margin-top: 2em;
      display: flex; }
      .navigation .profile .adress img {
        height: 1em;
        width: 1em;
        margin: 0em;
        display: block;
        padding-right: 0.5em; }
      .navigation .profile .adress a {
        display: block;
        font-family: Nunito;
        font-size: 11px;
        letter-spacing: 0.66px;
        border-bottom: 1pt solid $light-bg-color;
        text-decoration: none; }
  .navigation .menu {
    width: 100%;
    display: flex;
    flex-grow: 1;
    flex-direction: column;

  }

    .navigation .menu--footer {
      padding: 0.8em;
      opacity: 1;

      a {
        color: $secondary-text-color;
        opacity: 0.8;
        text-decoration: none;

        &:hover {
          opacity: 1;

        }
      }
    }
    .navigation .menu a {
      display: flex;
      padding: 1em;
      font-size: 1.1em;
      opacity: 1;
      align-items: center;
      cursor: pointer;
      text-decoration: none;
      -webkit-transition: all 0.2s;
      -moz-transition: all 0.2s;
      -ms-transition: all 0.2s;
      transition: all 0.2s; }
      .navigation .menu a img {
        width: 1.5em;
        height: 1.5em;
        display: block;
        /*clear: right;*/
        margin-right: 1em; }
      .navigation .menu a h2 {
        display: block;
        white-space: nowrap;
        overflow: hidden;
        -ms-text-overflow: ellipsis;
        /* Required for IE8 */
        -o-text-overflow: ellipsis;
        /* Required for Opera */
        text-overflow: ellipsis; }
    .navigation .menu .neuerBewerber {
      background-color: #ff805d;
      -webkit-border-radius: 3px;
      -moz-border-radius: 3px;
      -ms-border-radius: 3px;
      border-radius: 3px;
      font-family: Nunito;
      letter-spacing: 1.34px;
      text-transform: uppercase;
      color: $light-bg-color;
      padding: 0.8em;
      margin: 1em; }
      .navigation .menu .neuerBewerber h2 {
        font-size: 14px; 
        margin-top: 0.2em;
      }
      .navigation .menu .neuerBewerber img {
        width: 1.2em;
        height: 1.2em;
        margin-right: 0.4em;
      }
    .navigation .menu .neuerBewerber:hover {
      background-color: rgba(255, 128, 93, 0.8); }
    .navigation .menu .neuerBewerber ~ div {
      position: absolute;
      bottom: 0pt;
      width: 100%; }
    .navigation .menu a:hover,
    .navigation .menu a.router-link-exact-active {
      background-color: rgba(206, 216, 217, 0.28); }

@media screen and (max-width: 550px) {
  h2 {
    font-size: 2vw; }
  .neuerBewerber h2 {
    font-size: 1.7vw !important; } }

@media screen and (max-width: 780px) {
  .navigation {
    position: fixed;
    bottom: 0pt;
    width: 100vw;
    max-width: 100vw;
    height: auto; 
  }


  @supports(padding: max(0px)) {
    .navigation .menu {
      height: calc(4em + env(safe-area-inset-bottom) / 1.5) !important;
      padding-bottom: calc(env(safe-area-inset-bottom) / 1.5) !important;
    }
  }

  .menu--footer {
    display: none;
  }
    .navigation .profile {
      display: none; }
    .navigation .menu {
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      overflow: hidden;
      padding: 0em 0.6em;
      height: 4.5em; }
      .navigation .menu a {
        box-sizing: content-box;
        // height: calc(0.45em + 0.65em + 10pt);
        width: auto;
        margin: 0pt 0em; }
        .navigation .menu a h2 {
          display: none; }
        .navigation .menu a img {
          box-sizing: content-box;
          margin: 0pt;
          height: 1.2em;
          width: 1.2em; }
      .navigation .menu a:hover {
        background-color: inherit; }
  .neuerBewerber {
    margin: 0pt 0em !important; }
    .neuerBewerber h2 {
      font-size: 14px; }
    .neuerBewerber img {
      width: 1.2em;
      height: 1.2em;
      margin: 0pt calc(50% - 0.6em) !important; }
  .neuerBewerber ~ a {
    width: auto !important;
    margin: 0pt; } }

@media (max-width: 330px) {
  .navigation a {
    margin: 0pt !important;
    padding: 4px !important;
  }
  .neuerBewerber {
    padding: 0.2em !important;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/navigation.vue